var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 72,
    viewBox: "0 0 93 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 29.5879,
    width: 13.2858,
    height: 41.6998,
    fill: "#3F64FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5723,
    y: 41.4668,
    width: 13.2858,
    height: 29.8189,
    fill: "#3F64FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1426,
    y: 36.3418,
    width: 13.2858,
    height: 34.944,
    fill: "#3F64FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7148,
    y: 49.1562,
    width: 13.2858,
    height: 22.1312,
    fill: "#3F64FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 22.3633,
    width: 13.2858,
    height: 9.78431,
    fill: "#7335CB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5723,
    y: 11.1816,
    width: 13.2858,
    height: 30.2848,
    fill: "#7335CB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1426,
    y: 30.2852,
    width: 13.2858,
    height: 16.0742,
    fill: "#7335CB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7148,
    y: 44.2637,
    width: 13.2858,
    height: 4.89216,
    fill: "#7335CB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 13.5117,
    width: 13.2858,
    height: 8.85247,
    fill: "#8CD6A0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5723,
    width: 13.2858,
    height: 11.1821,
    fill: "#8CD6A0"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1426,
    y: 22.3633,
    width: 13.2858,
    height: 15.6083,
    fill: "#8CD6A0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7148,
    y: 35.4102,
    width: 13.2858,
    height: 8.85247,
    fill: "#8CD6A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackbar);
export default __webpack_public_path__ + "static/media/stackbar.3f724bf78532eb05b4bbcbcfa0fd903a.svg";
export { ForwardRef as ReactComponent };